export default __webpack_public_path__ + "static/media/ph.98835eeb.svg";